import { ExportCallLogsResponse } from '../call-log-service/call-log-service.types';
import { getRequest, postRequest } from '../request/request.service';
import {
  AnalyticsCallsResponse,
  Annotation,
  AnnotationContext,
  AnnotationPayload,
  RecordingUrlResponse,
} from './conversations-service.types';

export function getAnalyticCall({ analytics_call_id, translate }: AnnotationContext) {
  return getRequest<AnalyticsCallsResponse>(`/conversations/${analytics_call_id}`, {
    params: { translate },
  });
}

export function postAnnotation(params: AnnotationContext, data: AnnotationPayload) {
  return postRequest<Annotation>(`/conversations/${params.analytics_call_id}/annotations`, {
    data,
  });
}

export function getTxtFile(id: number) {
  return getRequest<ExportCallLogsResponse>(`/conversations/${id}/download_transcription`, {
    headers: { Accept: 'text/csv' },
    responseType: 'text',
  });
}

export function reviewedConversation(params: AnnotationContext, reviewed: boolean) {
  return postRequest<Annotation>(`/conversations/${params.analytics_call_id}/review_conversation`, {
    data: { reviewed },
  });
}

export type RecordingCategory = 'ai' | 'agent' | 'bridge';

export function getRecordingUrl(
  conversationId: number,
  category?: RecordingCategory,
  options: { download?: boolean } = {},
) {
  // download=true asks the backend to set Content-Disposition: attachment on
  // the resulting URL (S3 via response_content_disposition; local-dev via the
  // recording_file controller). Twilio URLs ignore the flag silently — we
  // can't rewrite their headers — but the browser save-as still works.
  const params: Record<string, string> = {};
  if (category) params.category = category;
  if (options.download) params.download = 'true';

  return getRequest<RecordingUrlResponse>(`/conversations/${conversationId}/get_recording_url`, {
    params: Object.keys(params).length ? params : undefined,
  });
}
